import { render } from "./NewChatMessageNotificationItem.vue?vue&type=template&id=8d7ca68e"
import script from "./NewChatMessageNotificationItem.vue?vue&type=script&lang=js"
export * from "./NewChatMessageNotificationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__